import React, { FC } from 'react';
import { Box, Divider, Link, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OverView } from 'models/workflow-step';
import { Link as RouterLink } from 'react-router-dom';
import { OrderFilter } from 'models/order';

type StaticStepBoxProps = {
    title: string;
    data: OverView;
    filters: OrderFilter;
};

const StaticStepBox: FC<StaticStepBoxProps> = ({ title, data, filters }: StaticStepBoxProps) => {
    const { t: translate } = useTranslation(['workflow', 'orders']);

    return (
        <Link
            component={RouterLink}
            to={`/workflow/orders?name=${title}&filters=${JSON.stringify(filters)}`}
            color="inherit"
            underline="none"
        >
            <Paper sx={{ height: '100%' }}>
                <Box p={1}>
                    <Typography variant="h4">{title}</Typography>
                    <Box my={1}>
                        <Divider />
                    </Box>
                    {data?.noOfReadyForInvoice ? (
                        <Box>
                            {data?.noOfReadyForInvoice} {translate('ORDERS')} {translate('orders:READY_FOR_INVOICE')}
                        </Box>
                    ) : undefined}
                    <Box>
                        {data?.noOfOrders} {translate('ORDERS')}
                    </Box>
                    <Box>
                        {data?.noOfConstructions} {translate('CONSTRUCTIONS')}
                    </Box>
                    <Box>
                        {data?.noOfActions} {translate('workflow:ACTIONS')}
                    </Box>
                </Box>
            </Paper>
        </Link>
    );
};

export default StaticStepBox;
